export default __webpack_public_path__ + "static/media/458627__tetrisrocker__clock.0b33c584.mp3";